import React from 'react';
import Button from '@/components/Button/Button';
import classes from './ResourceCardPanel.module.scss';

const ButtonPanel = ({ panelButtons, onPanelButtonClick, additionalClasses = '', disabled, openPanel }) => {
  const renderButtons = (buttons, onClick) => {
    return buttons.map((button, index) => {
      return (
        <div className={`${classes.panelButtons} ${openPanel === button?.panel ? classes.selected : ''}`} key={index}>
          <Button
            type={button.type}
            shape={button.shape}
            groupPosition={button.groupPosition}
            state={openPanel === button.panel ? 'selected' : ''}
            icon={button.icon}
            text={button.text}
            onButtonClick={() => (onClick ? onClick(button) : button.onClick(button))}
            additionalClasses={`${classes.panelButton} ${additionalClasses}`}
            styles={button.styles}
            disabled={disabled}
          />
        </div>
      );
    });
  };

  return <div className={classes.buttonPanelContainer}>{renderButtons(panelButtons, onPanelButtonClick)}</div>;
};

export default ButtonPanel;
